import { render, staticRenderFns } from "./index.vue?vue&type=template&id=cab062a4&"
import script from "./404.ts?vue&type=script&lang=ts&"
export * from "./404.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports